import { Modal } from "antd";
import FooterModal from "ui/components/Button/FooterModal";
import { useForm } from "react-hook-form";
import Field from "ui/components/Input/Field";
import { Checkbox, Flex, Box } from "@chakra-ui/react";
import useDescricaoPadraoArrecadacao from "core/features/arrecadacoes/useDescricaoPadrao";
import { useLoading, useLoadingStore } from "ui/components/GlobalLoading";
import { useEffect } from "react";
import SelectMonthYear from "ui/components/Input/SelectMonthYear";
import moment from "moment";
import SelectContasBancariasProcessarArrecadacao from "../Input/SelectContasBancariasProcessarArrecadacao/index";
import { ArrecadacaoDemonstrativoContasBancariasEnum } from "core/features/arrecadacoes/enums";

interface ParamsAdicionaisArrecadacaoForm {
  mesConsumo?: string;
  incluirDemonstrativo?: boolean;
  dataInicioDemonstrativo?: string;
  dataFimDemonstrativo?: string;
  descricaoCustomizada?: string;
  contasBancarias?: "todas" | "somenteDaCobranca";
}
interface ModalParamsAdicionaisArrecadacaoProps {
  isOpen: boolean;
  onSubmit: (form: ParamsAdicionaisArrecadacaoForm) => any;
  onClose: () => any;
  mes: string;
  showMesConsumo?: boolean;
}

function ModalParamsAdicionaisArrecadacao({
  isOpen,
  onClose,
  onSubmit,
  mes,
  showMesConsumo = false,
}: ModalParamsAdicionaisArrecadacaoProps) {
  const { update } = useLoadingStore();
  const { data, isLoading } = useDescricaoPadraoArrecadacao(mes);
  const { control, handleSubmit, watch, reset } =
    useForm<ParamsAdicionaisArrecadacaoForm>({
      defaultValues: {
        mesConsumo: moment(mes, "YYYY-MM")
          .subtract(1, "month")
          .format("YYYY-MM"),
        contasBancarias: "todas",
      },
    });

  const form = watch();

  useLoading(isLoading);

  useEffect(() => {
    if (data) {
      reset({
        descricaoCustomizada: data.descricao,
        contasBancarias: "todas",
      });
    }

    return () => update(false);
  }, [data, reset, update]);

  return (
    <Modal
      centered
      visible={isOpen}
      footer={
        <FooterModal
          showRegisterAnother={false}
          onClose={onClose}
          onSubmit={handleSubmit(onSubmit)}
          buttonCancelarText="Cancelar"
          primaryButtonText="Concluir"
        />
      }
      title={"Informações adicionais"}
      destroyOnClose
      onCancel={onClose}
      closable={true}
      width="600px"
      keyboard={false}
    >
      <Flex mb={4} mt={-4}>
        <Field
          control={control}
          name="descricaoCustomizada"
          label="Descrição das contas"
        />
      </Flex>

      <Field
        control={control}
        name="incluirDemonstrativo"
        render={({ field, isInvalid }) => (
          <Checkbox
            isChecked={field.value}
            isInvalid={isInvalid}
            onChange={() => {
              field.onChange(!field.value);
            }}
          >
            Incluir demonstrativo de receitas e despesas no boleto?
          </Checkbox>
        )}
      />

      {form.incluirDemonstrativo ? (
        <>
          <Flex gap={6} mt={4}>
            <Field
              control={control}
              name="dataInicioDemonstrativo"
              shouldUnregister
              label="Data inicial do período"
              inputProps={{
                type: "date",
              }}
            />
            <Field
              control={control}
              name="dataFimDemonstrativo"
              shouldUnregister
              label="Data final do período"
              rules={{ required: true }}
              inputProps={{
                type: "date",
              }}
            />
          </Flex>
          <Flex gap={6} mt={4}>
            <Field
              control={control}
              name="contasBancarias"
              shouldUnregister
              label="Contas bancárias"
              inputProps={{
                type: "date",
              }}
              render={({ field }) => (
                <SelectContasBancariasProcessarArrecadacao
                  style={{ width: "100%" }}
                  size="large"
                  defaultValue={
                    ArrecadacaoDemonstrativoContasBancariasEnum.Todas
                  }
                  {...field}
                />
              )}
            />
          </Flex>
        </>
      ) : null}

      {showMesConsumo ? (
        <Box mt={2}>
          <Field
            control={control}
            name="mesConsumo"
            label="Mês do consumo"
            shouldUnregister
            rules={{
              required: true,
            }}
            render={({ field }) => (
              <SelectMonthYear
                value={field.value ? moment(field.value, "YYYY-MM") : undefined}
                onChange={(date) => field.onChange(date?.format("YYYY-MM"))}
              />
            )}
          />
        </Box>
      ) : null}
    </Modal>
  );
}

export default ModalParamsAdicionaisArrecadacao;
